export const numberFormatter = (
  number: number,
  config: {
    locale?: string;
    suffix?: string | undefined;
    prefix?: string | undefined;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    millionSuffix?: string | undefined;
    thousandSuffix?: string | undefined;
    showAsMillion?: boolean;
    showAsThousand?: boolean;
  } = {
    locale: "nl",
    suffix: undefined,
    prefix: undefined,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    millionSuffix: "M",
    thousandSuffix: "K",
    showAsMillion: false,
    showAsThousand: false,
  },
) => {
  let formattedNumber: string = "";

  // Function to format the number based on the configuration
  const formatNumber = (value: number): string => {
    return new Intl.NumberFormat(config.locale, {
      minimumFractionDigits: config.minimumFractionDigits,
      maximumFractionDigits: config.maximumFractionDigits,
    }).format(value);
  };

  // Check if showing as million is enabled and the number is greater than or equal to 1 million
  if (config.showAsMillion && Math.abs(number) >= 1e6) {
    formattedNumber =
      formatNumber(Math.round(number / 1e6)) + (config.millionSuffix || "M");
  }
  // Check if showing as thousand is enabled and the number is greater than or equal to 1 thousand
  else if (config.showAsThousand && Math.abs(number) >= 1e3) {
    formattedNumber =
      formatNumber(Math.round(number / 1e3)) + (config.thousandSuffix || "K");
  }
  // Otherwise, format the number as is
  else {
    formattedNumber = formatNumber(number);
  }

  // Append prefix and suffix if provided
  if (config.prefix !== undefined) {
    formattedNumber = `${config.prefix}${formattedNumber}`;
  }

  if (config.suffix !== undefined) {
    formattedNumber = `${formattedNumber}${config.suffix}`;
  }

  return formattedNumber;
};
